import './App.css';
import { ThemeProvider, Theme, StyledEngineProvider, CssBaseline, styled, Paper } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { appTheme } from "./theme";
import PageRoute from "./Routes";
import AppBar from "./components/Navbar/Navbar";
import { AuthProvider } from './components/Auth/AuthProvider';
import { DataProvider } from './store/DataProvider'
import Maintenance from './pages/Maintenance/Maintenance';
import { isMaintenanceMode, queryParam } from './maintenance';
import { HelmetProvider } from 'react-helmet-async';
import { VersionHistoryDrawer } from './components/VersionHistory/VersionHistoryDrawer';
import { EventCommentsDrawer } from './components/EventComments/EventCommentsDrawer';
import { useSidebarLayout } from './hooks/useSidebarLayout';


declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

const StyledPaper = styled(Paper, {
  shouldForwardProp: (prop) => prop !== 'sidebarWidth'
})<{ sidebarWidth: number }>(({ sidebarWidth }) => ({
  marginLeft: 90,
  marginRight: 20 + sidebarWidth,
  boxShadow: 'none',
  transition: 'margin-right 225ms cubic-bezier(0, 0, 0.2, 1)',
}))

function AppLayout() {
  const { sidebarWidth } = useSidebarLayout()

  return (
    <>
      <AppBar />
      <StyledPaper sidebarWidth={sidebarWidth}>
        <PageRoute />
      </StyledPaper>
      <VersionHistoryDrawer />
      <EventCommentsDrawer />
    </>
  )
}

function App() {
  const isMaintenance = isMaintenanceMode;
  if (isMaintenance && !window.location.search.includes(queryParam)) {
    return <Maintenance />
  }

  return (
    <HelmetProvider>
      <AuthProvider>
        <DataProvider>
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={appTheme}>
              <CssBaseline enableColorScheme />
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <AppLayout />
              </LocalizationProvider>
            </ThemeProvider>
          </StyledEngineProvider>
        </DataProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
